import { render, staticRenderFns } from "./OpenPointsStatus.vue?vue&type=template&id=434e2977&scoped=true"
import script from "./OpenPointsStatus.vue?vue&type=script&lang=js"
export * from "./OpenPointsStatus.vue?vue&type=script&lang=js"
import style0 from "./OpenPointsStatus.vue?vue&type=style&index=0&id=434e2977&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434e2977",
  null
  
)

export default component.exports